import React from "react";
import { Row, Col, Button } from 'antd';
import SelectComponent from '../generic/select/select';
import Span from "../generic/span/span";
import Title from "../generic/title/title";
import InputText from "../generic/input/input-text";
import InputRut from "../generic/input/input-rut";
import InputNumerico from "../generic/input/input-numerico";
import TextAera from "../generic/text-area/text-area";
import SelectComponentEmpty from "../generic/select/select-empty";
import UploadeFileReclamo from "../generic/upload/upload"
import {
    GoogleReCaptchaProvider,
    GoogleReCaptcha
} from 'react-google-recaptcha-v3';

const { obtenerSubMotivo, obtenerTipoReclamo, valRut, valMail, valNombre, valTexto, valNumero, valForm, validaEstados, valCaptcha } = require("../generic/utils/utils");

export default class AtencionCliente extends React.Component {

    constructor(props) {
        super();
        this.verifyCaptcha = this.verifyCaptcha.bind(this);
        let precargaForm = props.precargaForm;
        this.state = {
            precarga: precargaForm !== null ? true : false,
            titulo: props.titulo,
            empresa: props.empresa,
            activarSpanMotivo: false,
            txtSpanMotivo: '',
            activarSpanSubMotivo: false,
            txtSpanSubMotivo: '',
            activarSpanTipoReclamo: false,
            txtSpanTipoReclamo: '',
            activarSpanNombre: false,
            txtSpanNombre: '',
            activarSpanApPat: false,
            txtSpanApPat: '',
            activarSpanApMat: false,
            txtSpanApMat: '',
            activarSpanRut: false,
            txtSpanRut: '',
            activarSpanCorreo: false,
            txtSpanCorreo: '',
            activarSpanTelefono: false,
            txtSpanTelefono: '',
            activarSpanCelular: false,
            txtSpanCelular: '',
            activarSpanComentario: false,
            txtSpanComentario: '',
            activarSpanContador: false,
            txtSpanContador: 0,
            activarSpanTicket: false,
            txtSpanTicket: '',
            activarSpanTrx: false,
            txtSpanTrx: '',
            activarSpanBol1: false,
            txtSpanBol1: '',
            activarSpanBol2: false,
            txtSpanBol2: '',
            activarSpanBol3: false,
            txtSpanBol3: '',
            txtFlgActivo: '',
            activarSpanFlg: false,
            activarSpanCaptcha: false,
            txtSpanCaptcha: '',
            data: props.data,
            dataSubMotivo: precargaForm !== null ? props.dataSubMotivo : [],
            dataTipoReclamo: precargaForm !== null ? props.dataTpReclamo : [],
            selectMotivo: precargaForm !== null ? precargaForm.motivo : -1,
            seleccionSubMotivo: precargaForm !== null ? precargaForm.subMotivo : -1,
            seleccionTipoReclamo: precargaForm !== null ? precargaForm.tipoReclamo : -1,
            inactiveSubMotivo: true,
            inactiveTipoReclamo: true,
            flg: precargaForm !== null ? (precargaForm.flg === 'S' ? 'block' : 'none') : 'none',
            flgEquipaje: precargaForm !== null ? (precargaForm.flgEquipaje === 'block' ? 'block' : 'none') : 'none',
            form: {
                motivo: precargaForm !== null ? precargaForm.motivo : null,
                subMotivo: precargaForm !== null ? precargaForm.subMotivo : null,
                tipoReclamo: precargaForm !== null ? precargaForm.tipoReclamo : null,
                nombre: precargaForm !== null ? precargaForm.nombre : null,
                apPat: precargaForm !== null ? precargaForm.apPat : null,
                apMat: precargaForm !== null ? precargaForm.apMat : null,
                rut: precargaForm !== null ? precargaForm.rut : null,
                dv: precargaForm !== null ? precargaForm.dv : null,
                correo: precargaForm !== null ? precargaForm.correo : null,
                telefono: precargaForm !== null ? precargaForm.telefono : null,
                celular: precargaForm !== null ? precargaForm.celular : null,
                ticket: precargaForm !== null ? precargaForm.ticket : null,
                transaccion: precargaForm !== null ? precargaForm.transaccion : null,
                bole1: precargaForm !== null ? precargaForm.bole1 : null,
                bole2: precargaForm !== null ? precargaForm.bole2 : null,
                bole3: precargaForm !== null ? precargaForm.bole3 : null,
                comentario: precargaForm !== null ? precargaForm.comentario : null,
                flg: precargaForm !== null ? precargaForm.flg : null,
                bole: [],
                files: precargaForm !== null ? precargaForm.files : null,
                flgEquipaje: precargaForm !== null ? precargaForm.flgEquipaje : null,
                textos: props.textos.FORMULARIO_RECLAMOS,
            },
            captchaVerify: false
        }
    }

    validaRut = async (event) => {

        let data = await valRut(event);
        let formValue = this.state.form;

        formValue.rut = data.rut;
        formValue.dv = data.dv;

        this.setState({ activarSpanRut: data.activeSpan, txtSpanRut: data.txtSpan, form: formValue })

    }

    validaCorreo = async (event) => {

        let data = await valMail(event);
        let formValue = this.state.form;

        formValue.correo = data.correo;

        this.setState({ activarSpanCorreo: data.activeSpan, txtSpanCorreo: data.txtSpan, form: formValue });

    }

    validaNombre = async (event) => {

        let data = await valNombre(event);
        let formValue = this.state.form;
        let id = event.target.id;

        switch (id) {
            case "numticketsoli":
                formValue.ticket = data.texto;
                this.setState({ activarSpanTicket: data.activeSpan, txtSpanTicket: data.txtSpan, form: formValue });
                break;
            case "appatsoli":
                formValue.apPat = data.texto;
                this.setState({ activarSpanApPat: data.activeSpan, txtSpanApPat: data.txtSpan, form: formValue })
                break;
            case "apmatsoli":
                formValue.apMat = data.texto;
                this.setState({ activarSpanApMat: data.activeSpan, txtSpanApMat: data.txtSpan, form: formValue })
                break;
            case "nomsoli":
                formValue.nombre = data.texto;
                this.setState({ activarSpanNombre: data.activeSpan, txtSpanNombre: data.txtSpan, form: formValue })
                break;
            default:
                break;
        }
    }

    validaTexto = async (event) => {

        let data = await valTexto(event);
        let formValue = this.state.form;

        formValue.comentario = data.texto;

        this.setState({ activarSpanComentario: data.activeSpan, txtSpanComentario: data.txtSpan, activarSpanContador: data.activaCon, txtSpanContador: data.txtCon, form: formValue })

    }

    validaNumerico = async (event) => {

        let data = await valNumero(event);

        let formValue = this.state.form;
        let id = event.target.id;

        switch (id) {
            case "trxsoli":
                formValue.transaccion = data.numero;
                this.setState({ activarSpanTrx: data.activeSpan, txtSpanTrx: data.txtSpan, activarSpanFlg: false, form: formValue });
                break;

            case "numbol1":
                formValue.bole1 = data.numero;
                this.setState({ activarSpanBol1: data.activeSpan, txtSpanBol1: data.txtSpan, activarSpanFlg: false, form: formValue });
                break;

            case "numbol2":
                formValue.bole2 = data.numero;
                this.setState({ activarSpanBol2: data.activeSpan, txtSpanBol2: data.txtSpan, form: formValue });
                break;

            case "numbol3":
                formValue.bole3 = data.numero;
                this.setState({ activarSpanBol3: data.activeSpan, txtSpanBol3: data.txtSpan, form: formValue });
                break;

            case "telesoli":
                formValue.telefono = data.numero;
                this.setState({ activarSpanTelefono: data.activeSpan, txtSpanTelefono: data.txtSpan, form: formValue });
                break;

            case "celsoli":
                formValue.celular = data.numero;
                this.setState({ activarSpanCelular: data.activeSpan, txtSpanCelular: data.txtSpan, form: formValue });
                break;

            default:
                break;
        }
    }

    setSubMotivo = async (e) => {

        let formValue = this.state.form;
        this.setState({ dataSubMotivo: [], inactiveSubMotivo: true, seleccionSubMotivo: -1, dataTipoReclamo: [], inactiveTipoReclamo: true, seleccionTipoReclamo: -1, flg: 'none', precarga: false });

        if (e !== undefined) {
            let data = await obtenerSubMotivo(e);
            let subMotivo = null;
            let tpReclamo = null;
            let dataTpReclamo = null;

            if (data.inStep !== 1) {
                this.props.onChange(data);
            }

            formValue.motivo = e;
            formValue.subMotivo = null;
            formValue.tipoReclamo = null;

            if (data.data.length === 1) {
                subMotivo = data.data[0].cod_submotivo;
                dataTpReclamo = await obtenerTipoReclamo(subMotivo, 'S', 0);
                if (dataTpReclamo.data.length === 1) {
                    tpReclamo = dataTpReclamo.data[0].cod_tipo_reclamo;
                    formValue.tipoReclamo = tpReclamo;
                }
                formValue.flg = "N";
                formValue.subMotivo = subMotivo;
            }

            this.setState({
                activarSpanMotivo: false, txtSpanMotivo: '', dataSubMotivo: data.data, inactiveSubMotivo: false, flg: 'none', form: formValue,
                activarSpanSubMotivo: false, txtSpanSubMotivo: '', activarSpanTipoReclamo: false, txtSpanTipoReclamo: '',
                seleccionSubMotivo: subMotivo, dataTipoReclamo: dataTpReclamo !== null ? dataTpReclamo.data : [], seleccionTipoReclamo: tpReclamo,
                inactiveTipoReclamo: subMotivo !== null ? false : true
            });

        } else {

            formValue.bole1 = null;
            formValue.bole2 = null;
            formValue.bole3 = null;
            formValue.motivo = null;
            formValue.flg = null;
            formValue.subMotivo = null;
            formValue.tipoReclamo = null;
            formValue.transaccion = null;

            this.setState({ activarSpanSubMotivo: false, activarSpanTipoReclamo: false, activarSpanMotivo: true, txtSpanMotivo: 'Seleccione un tipo de requerimiento', flg: 'none', form: formValue })
        }
    }

    setTipoReclamo = async (e) => {

        let formValue = this.state.form;
        this.setState({ dataTipoReclamo: [], inactiveTipoReclamo: true, seleccionTipoReclamo: -1 });

        if (e !== undefined) {

            let data = await obtenerTipoReclamo(e, 'S', 0);

            if (data.inStep !== 1) {
                this.props.onChange(data);
            }

            formValue.subMotivo = e;
            formValue.tipoReclamo = null;
            formValue.flgEquipaje = e === 805 ? 'block' : 'none';

            this.setState({ activarSpanSubMotivo: false, txtSpanSubMotivo: '', dataTipoReclamo: data.data, inactiveTipoReclamo: false, seleccionTipoReclamo: null, flg: 'none', form: formValue, flgEquipaje: e === 805 ? 'block' : 'none' });

        } else {

            formValue.bole1 = null;
            formValue.bole2 = null;
            formValue.bole3 = null;
            formValue.subMotivo = null;
            formValue.flg = null;
            formValue.tipoReclamo = null;
            formValue.transaccion = null;
            this.setState({ activarSpanTipoReclamo: false, activarSpanSubMotivo: true, txtSpanSubMotivo: 'Ingrese su motivo de reclamo', activarSpan: true, txtSpanMotivo: 'Ingrese un motivo valido', flg: 'none', form: formValue });
        }
    }

    setFlg = async (e, d) => {


        let formValue = this.state.form;
        let activo = d === 'S' ? 'block' : 'none';

        if (e !== undefined && d !== undefined) {

            formValue.tipoReclamo = e;
            formValue.flg = d;
            if (activo === 'none') {
                formValue.bole1 = null;
                formValue.bole2 = null;
                formValue.bole3 = null;
                formValue.transaccion = null;
            }

            this.setState({ flg: activo, form: formValue, activarSpanTipoReclamo: false, txtSpanTipoReclamo: '' });

        } else {

            formValue.tipoReclamo = null
            formValue.bole1 = null;
            formValue.bole2 = null;
            formValue.bole3 = null;
            formValue.flg = null;
            formValue.tipoReclamo = null;
            formValue.transaccion = null;
            this.setState({ flg: activo, form: formValue, activarSpanTipoReclamo: true, txtSpanTipoReclamo: 'Ingrese el submotivo de reclamo' });
        }
    }

    setValidaciones(data, txtFlg, spanFlg) {
        this.setState({
            activarSpanMotivo: data.motivoSpan,
            txtSpanMotivo: data.motivoTxt,
            activarSpanSubMotivo: data.subMotivoSpan,
            txtSpanSubMotivo: data.subMotivoTxt,
            activarSpanTipoReclamo: data.tipoReclamoSpan,
            txtSpanTipoReclamo: data.tipoReclamoTxt,
            activarSpanNombre: data.nombreSpan,
            txtSpanNombre: data.nombreTxt,
            activarSpanApPat: data.apPatSpan,
            txtSpanApPat: data.apPatTxt,
            activarSpanApMat: data.apMatSpan,
            txtSpanApMat: data.apMatTxt,
            activarSpanRut: data.rutSpan,
            txtSpanRut: data.rutTxt,
            activarSpanCorreo: data.correoSpan,
            txtSpanCorreo: data.correoTxt,
            activarSpanCelular: data.celularSpan,
            txtSpanCelular: data.celularTxt,
            activarSpanComentario: data.comentarioSpan,
            txtSpanComentario: data.comentarioTxt,
            txtFlgActivo: txtFlg,
            activarSpanFlg: spanFlg
        })
    }

    cargaFile = async (e) => {

        let arch = [];
        let count = 0;
        let formValue = this.state.form;

        e.forEach(number => {
            if (parseInt(number.size) < 2281 && count < 3) {
                arch.push(number)
                count = count + 1;
            }
        })

        formValue.files = arch;

        this.setState({ form: formValue })

    }

    verifyCaptcha(value) {
        if (value) {
            this.setState({
                captchaVerify: true
            })
        }
    }

    handleOk = async (e) => {

        let estado = this.state;
        let verifyCaptcha = await valCaptcha(this.state.captchaVerify);
        let flg = estado.flg !== 'none';
        let flgValid = true;
        let txtFlg = null;
        let spanFlg = false;
        let data;
        let dataSubMotivo = this.state.dataSubMotivo;
        let dataTpReclamo = this.state.dataTipoReclamo;
        let validacionEstados = await validaEstados(estado);

        this.setState({
            txtSpanCaptcha: verifyCaptcha.txtSpan,
            activarSpanCaptcha: verifyCaptcha.activeSpan
        });

        if (flg && estado.form.transaccion === null && estado.form.bole1 === null) {
            flgValid = false;
            spanFlg = true;
            txtFlg = 'Es necesario que se indique un numero de boleto o transaccion';
        }

        data = await valForm(estado.form);
        if (flgValid && validacionEstados && data.validacion && verifyCaptcha.verifyCaptcha) {
            this.props.onComplete(estado.form, dataSubMotivo, dataTpReclamo);
        } else {
            this.setValidaciones(data, txtFlg, spanFlg);
        }
    }

    render() {
        let textoAdjunto = "Puede adjuntar hasta 3 archivos para respaldar su requerimiento, éstos pueden ser comprobantes de compra, boletos, entre otros. Con un peso máximo de 2 MB cada uno";

        let activarSpanMotivo = this.state.activarSpanMotivo;
        let activarSpanSubMotivo = this.state.activarSpanSubMotivo;
        let activarSpanTipoReclamo = this.state.activarSpanTipoReclamo;
        let activarSpanNombre = this.state.activarSpanNombre;
        let activarSpanApPat = this.state.activarSpanApPat;
        let activarSpanApMat = this.state.activarSpanApMat;
        let activarSpanRut = this.state.activarSpanRut;
        let activarSpanCorreo = this.state.activarSpanCorreo;
        let activarSpanTelefono = this.state.activarSpanTelefono;
        let activarSpanCelular = this.state.activarSpanCelular;
        let activarSpanComentario = this.state.activarSpanComentario;
        let activarSpanContador = this.state.activarSpanContador;
        let activarSpanTicket = this.state.activarSpanTicket;
        let activarSpanTrx = this.state.activarSpanTrx;
        let activarSpanBol1 = this.state.activarSpanBol1;
        let activarSpanBol2 = this.state.activarSpanBol2;
        let activarSpanBol3 = this.state.activarSpanBol3;

        let inactiveSubMotivo = this.state.precarga ? false : this.state.inactiveSubMotivo;
        let inactiveTipoReclamo = this.state.precarga ? false : this.state.inactiveTipoReclamo;

        let seleccionMotivo = this.state.selectMotivo;
        let seleccionSubMotivo = this.state.seleccionSubMotivo;
        let seleccionTipoReclamo = this.state.seleccionTipoReclamo;

        let dataSelectSubMotivo = this.state.dataSubMotivo;
        let dataSelectTipoReclamo = this.state.dataTipoReclamo;
        let activarSpanFlg = this.state.activarSpanFlg;

        let comSelSubMotivo = seleccionSubMotivo === -1 ? <SelectComponentEmpty id="subMotivo" onChange={this.setTipoReclamo} data={[]} selected={seleccionSubMotivo} inActive={inactiveSubMotivo} />
            : <SelectComponent id="subMotivo" onChange={this.setTipoReclamo} data={dataSelectSubMotivo} selected={seleccionSubMotivo} inActive={inactiveSubMotivo} />;


        let comSelTipoReclamo = seleccionTipoReclamo === -1 ? <SelectComponentEmpty id="tipoReclamo" onChange={this.setFlg} data={[]} selected={seleccionTipoReclamo} inActive={inactiveTipoReclamo} />
            : <SelectComponent id="tipoReclamo" onChange={this.setFlg} data={dataSelectTipoReclamo} selected={seleccionTipoReclamo} inActive={inactiveTipoReclamo} />

        let flgActivo = this.state.flg !== 'none' ? <>

            <div className="label" style={{ display: this.state.flg, color: 'red' }}>
                <p></p>
                <Span css="word" text={"Debes ingresar tu Número de Boleto o Número de Transacción:"} />
                {activarSpanFlg ? <div className="informacion label"> <Span text={this.state.txtFlgActivo} /></div> : <div></div>}
            </div>
            <Row className="transaction-radio-row">
                <Col flex="1 1 150px">
                    <div className="label">
                        <Span text={"Número de Transacción:"} />
                    </div>
                    <InputNumerico id="trxsoli" placeholder="Número de Transacción" value={this.state.form.transaccion} max={12} onChange={this.validaNumerico} />
                    {activarSpanTrx ? <div className="informacion label"> <Span text={this.state.txtSpanTrx} /></div> : <div></div>}
                </Col>
                <Col flex="0 1 11px"></Col>
                <Col flex="1 1 150px">
                    <div style={{ width: "97%" }}>
                        <div className="label">
                            <Span text={"Número de Boleto 1:"} />
                        </div>
                        <InputNumerico id="numbol1" placeholder="Número de Boleto 1" value={this.state.form.bole1} max={12} onChange={this.validaNumerico} />
                        {activarSpanBol1 ? <div className="informacion label"> <Span text={this.state.txtSpanBol1} /></div> : <div></div>}
                    </div>
                </Col>
            </Row>
            <Row className="transaction-radio-row">
                <Col flex="1 1 150px">
                    <div className="label">
                        <Span text={"Número de Boleto 2:"} />
                    </div>
                    <InputNumerico id="numbol2" placeholder="Número de Boleto 2" value={this.state.form.bole2} max={12} onChange={this.validaNumerico} />
                    {activarSpanBol2 ? <div className="informacion label"> <Span text={this.state.txtSpanBol2} /></div> : <div></div>}
                </Col>
                <Col flex="0 1 11px"></Col>
                <Col flex="1 1 150px">
                    <div style={{ width: "97%" }}>
                        <div className="label">
                            <Span text={"Número de Boleto 3:"} />
                        </div>
                        <InputNumerico id="numbol3" placeholder="Número de Boleto 3" value={this.state.form.bole3} max={12} onChange={this.validaNumerico} />
                        {activarSpanBol3 ? <div className="informacion label"> <Span text={this.state.txtSpanBol3} /></div> : <div></div>}
                    </div>
                </Col>
            </Row>
        </> : <></>;

        let flgEquipajeActivo = this.state.flgEquipaje !== 'none' ? <>
            <div className="label">
                <Span text={"Número Ticket Equipaje:"} />
            </div>
            <InputText id="numticketsoli" placeholder="Número Ticket Equipaje" value={this.state.form.ticket} max={12} onlyText={false} onChange={this.validaNombre} />
            {activarSpanTicket ? <div className="informacion label"> <Span text={this.state.txtSpanTicket} /></div> : <div></div>}
        </> : <></>;

        return (
            <div className="box-content">
                <Title h={1} text={this.state.form.textos.HEADER.TITULOS.TIT_RECLAMO} />
                <div className="texto-justify"><p><Span text={this.state.form.textos.HEADER.PARRAFO.PARRAFO_1} /> <Span text={this.state.form.textos.HEADER.PARRAFO.PARRAFO_2} /> <Span text={this.state.form.textos.HEADER.PARRAFO.PARRAFO_3} /></p></div>
                <div className="texto-justify_devolucion"><p><Span text={this.state.form.textos.HEADER.PARRAFO.PARRAFO_4} /></p></div>
                <Row className="transaction-row">
                    <Row className="transaction-radio-row">
                        <Col flex="1 1 150px">
                            <div className="texto-justify">
                                <Span css="word" text={"Mi requerimiento es:"} />
                            </div>
                            <SelectComponent id="motivo" onChange={this.setSubMotivo} data={this.state.data} selected={seleccionMotivo} inActive={false} />
                            {activarSpanMotivo ? <div className="informacion label"> <Span text={this.state.txtSpanMotivo} /></div> : <div></div>}
                        </Col>
                        <Col flex="0 1 11px"></Col>
                        <Col flex="1 1 150px">
                        </Col>
                    </Row>

                    <Row className="transaction-radio-row">
                        <Col flex="1 1 150px">
                            <div className="texto-justify">
                                <Span css="word" text={"El motivo de mi requerimiento es:"} />
                            </div>
                            {comSelSubMotivo}
                            {activarSpanSubMotivo ? <div className="informacion label"> <Span text={this.state.txtSpanSubMotivo} /></div> : <div></div>}
                        </Col>
                        <Col flex="0 1 11px"></Col>
                        <Col flex="1 1 150px">

                        </Col>
                    </Row>

                    <Row className="transaction-radio-row">
                        <Col flex="1 1 150px">
                            <div className="label">
                                <Span css="word" text={"La mejor opción que representa el motivo de mi requerimiento es:"} />
                            </div>
                            {comSelTipoReclamo}
                            {activarSpanTipoReclamo ? <div className="informacion label"> <Span text={this.state.txtSpanTipoReclamo} /></div> : <div></div>}
                        </Col>
                        <Col flex="0 1 11px"></Col>
                        <Col flex="1 1 150px">
                        </Col>
                    </Row>

                    <Row className="transaction-radio-row">
                        <Col flex="1 1 150px">
                            <div className="label">
                                <Span css="word" text={"Nombres:"} />
                            </div>
                            <InputText id="nomsoli" placeholder="Nombres" value={this.state.form.nombre} max={20} onlyText={true} onChange={this.validaNombre} />
                            {activarSpanNombre ? <div className="informacion label"> <Span text={this.state.txtSpanNombre} /></div> : <div></div>}
                        </Col>
                        <Col flex="0 1 11px"></Col>
                        <Col flex="1 1 150px">
                            <div style={{ width: "97%" }}>
                                <div className="label">
                                    <Span css="word" text={"Apellido Paterno:"} />
                                </div>
                                <InputText id="appatsoli" placeholder="Apellido Paterno" value={this.state.form.apPat} max={20} onlyText={true} onChange={this.validaNombre} />
                                {activarSpanApPat ? <div className="informacion label"> <Span text={this.state.txtSpanApPat} /></div> : <div></div>}
                            </div>
                        </Col>
                    </Row>

                    <Row className="transaction-radio-row">
                        <Col flex="1 1 150px">
                            <div className="label">
                                <Span css="word" text={"Apellido Materno:"} />
                            </div>
                            <InputText id="apmatsoli" placeholder="Apellido Materno" value={this.state.form.apMat} max={20} onlyText={true} onChange={this.validaNombre} />
                            {activarSpanApMat ? <div className="informacion label"> <Span text={this.state.txtSpanApMat} /></div> : <div></div>}
                        </Col>
                        <Col flex="0 1 11px"></Col>
                        <Col flex="1 1 150px">
                            <div style={{ width: "97%" }}>
                                <div className="label">
                                    <Span css="word" text={"Rut:"} />
                                </div>
                                <InputRut id="rutsoli" placeholder="Rut" value={this.state.form.rut} max={13} onChange={this.validaRut} />
                                {activarSpanRut ? <div className="informacion label"> <Span text={this.state.txtSpanRut} /></div> : <div></div>}
                            </div>
                        </Col>
                    </Row>

                    <Row className="transaction-radio-row">
                        <Col flex="1 1 150px">
                            <div className="label">
                                <Span css="word" text={"Correo:"} />
                            </div>
                            <InputText id="correo" placeholder="Correo" value={this.state.form.correo} max={60} onlyText={false} onChange={this.validaCorreo} />
                            {activarSpanCorreo ? <div className="informacion label"> <Span text={this.state.txtSpanCorreo} /></div> : <div></div>}
                        </Col>
                        <Col flex="0 1 11px"></Col>
                        <Col flex="1 1 150px">
                            <div style={{ width: "97%" }}>
                                <div className="label">
                                    <Span text={"Teléfono:"} />
                                </div>
                                <InputNumerico id="telesoli" placeholder="Numero de telefono" value={this.state.form.telefono} max={18} onChange={this.validaNumerico} />
                                {activarSpanTelefono ? <div className="informacion label"> <Span text={this.state.txtSpanTelefono} /></div> : <div></div>}
                            </div>
                        </Col>
                    </Row>

                    <Row className="transaction-radio-row">
                        <Col flex="1 1 150px">
                            <div className="label">
                                <Span css="word" text={"Celular (9 dígitos):"} />
                            </div>
                            <InputNumerico id="celsoli" placeholder="Número de celular" value={this.state.form.celular} max={18} onChange={this.validaNumerico} />
                            {activarSpanCelular ? <div className="informacion label"> <Span text={this.state.txtSpanCelular} /></div> : <div></div>}
                        </Col>
                        <Col flex="0 1 11px"></Col>
                        <Col flex="1 1 150px">
                            <div style={{ width: "97%" }}>
                                {flgEquipajeActivo}
                            </div>
                        </Col>
                    </Row>

                    {flgActivo}

                    <Row className="transaction-radio-row">
                        <Col flex="1 1 150px">
                            <div className="label">
                                <Span css="word" text={"Comentarios:"} />
                            </div>
                            <TextAera id="comensoli" placeholder="Comentarios" value={this.state.form.comentario} max={1050} onChange={this.validaTexto} />
                            {activarSpanComentario ? <div className="informacion label"><Span text={this.state.txtSpanComentario} /></div> : <div></div>}
                            {activarSpanContador ? <div className="label"> <Span text={this.state.txtSpanContador} /></div> : <div></div>}
                        </Col>
                        <Col flex="0 1 11px"></Col>
                        <Col flex="1 1 150px">
                            <div style={{ width: "97%" }}>
                            </div>
                        </Col>
                    </Row>

                    <Row className="transaction-radio-row">
                        <Col flex="1 1 150px">
                            <div className="label">
                                <p></p><Span text={textoAdjunto} />
                                <UploadeFileReclamo onChange={this.cargaFile} preload={this.state.form.files} />
                            </div>
                        </Col>
                        <Col flex="0 1 11px"></Col>
                        <Col flex="1 1 150px">
                            <div style={{ width: "97%" }}>
                            </div>
                        </Col>
                    </Row>

                    <Row className="transaction-radio-row">
                        <Col flex="1 1 150px">
                            <div className="recaptcha">
                                <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_WEB_KEY}>
                                    <GoogleReCaptcha onVerify={this.verifyCaptcha} />
                                </GoogleReCaptchaProvider>
                            </div>
                        </Col>
                    </Row>

                    <Row className="transaction-radio-row">
                        <Col flex="1 1 150px">
                            <Button color="success" onClick={() => this.handleOk(this.state.form)}>Enviar</Button>{' '}
                        </Col>
                        <Col flex="0 1 11px"></Col>
                        <Col flex="1 1 150px">
                            <div style={{ width: "97%" }}>
                            </div>
                        </Col>
                    </Row>
                </Row>

            </div>
        );
    }
}
